var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar'),_c('p',{staticClass:"text-white py-10 text-2xl text-center"},[_vm._v("tutorial video")]),_c('div',{staticClass:"m-4 md:w-2/3 md:mx-auto mb-20"},[_c('tutorial-video')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }